module.exports = __webpack_public_path__ + "img/4_l.1b5a769b.svg";